import { Behavior } from "../Behavior";
import type { IGrid } from "../types";
import type { Particle } from "../Particle";

export class TemperatureNormalization extends Behavior {
    ambientTemp: number;
    rate: number;

    constructor(ambientTemp: number = 20, rate: number = 0.5) {
        super();
        this.ambientTemp = ambientTemp;
        this.rate = rate;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        if (particle.temperature > this.ambientTemp) {
            particle.temperature = Math.max(this.ambientTemp, particle.temperature - this.rate);
        } else if (particle.temperature < this.ambientTemp) {
            particle.temperature = Math.min(this.ambientTemp, particle.temperature + this.rate);
        }
    }
}
